import { gsap } from "../../../node_modules/gsap";
import { MotionPathPlugin } from "../../../node_modules/gsap/MotionPathPlugin";

document.addEventListener("alpine:init", () => {
    gsap.registerPlugin(MotionPathPlugin);

    window.pegasusInitBgPattern = function () {
        const patterns = document.querySelectorAll(".pegasus-bg-pattern");

        patterns.forEach(function (pattern) {
            if (!pattern.classList.contains("gsap-init")) {
                pattern.classList.add("gsap-init");

                gsap.to("#bgPattern" + pattern.dataset.id, {
                    duration: 30,
                    repeat: -1,
                    ease: "none",
                    motionPath: {
                        path: "#bgPatternPath" + pattern.dataset.id,
                        align: "#bgPatternPath" + pattern.dataset.id,
                        autoRotate: true,
                        alignOrigin: [0.5, 0.5],
                    },
                });

                gsap.to("#bgPattern2" + pattern.dataset.id, {
                    duration: 35,
                    repeat: -1,
                    ease: "none",
                    motionPath: {
                        path: "#bgPatternPath2" + pattern.dataset.id,
                        align: "#bgPatternPath2" + pattern.dataset.id,
                        autoRotate: true,
                        alignOrigin: [0.5, 0.5],
                    },
                });
            }
        });
    };

    pegasusInitBgPattern();
});
